import { useContext } from 'react'
import { collection, doc, setDoc, deleteDoc } from 'firebase/firestore'
import { firebase_firestore } from '../common/firebaseConfig'
import { useApplicationSuiteContext } from '../contexts/ApplicationSuiteProvider'
import useRecentlyViewedBacktests from './useRecentlyViewedBacktests'
import { FolderMembershipContext } from '../app/showcase/contexts/FolderMembershipContext'

function useFavoriteBacktest(backtest: any) {
  const { usermeta, savedBacktestsMap } = useApplicationSuiteContext()
  const [, setRecentlyViewedBacktests] = useRecentlyViewedBacktests()
  // undefined outside ShowcaseProvider (most tabs have no concept of
  // folders) — folder cleanup below is skipped there rather than crashing.
  const folderMembership = useContext(FolderMembershipContext)

  const isFavorited = !!savedBacktestsMap[backtest?.id]

  const toggleFavorite = async () => {
    const savedShowcaseRef = collection(
      firebase_firestore,
      `usermeta/${usermeta.gcid}/savedShowcase`
    )
    try {
      if (isFavorited) {
        await deleteDoc(doc(savedShowcaseRef, backtest.id))
        // Folders are only meaningful within Favorites — an unfavorited
        // backtest shouldn't stay in one. folderMembership.folders is only
        // populated while viewing Favorites, so this naturally no-ops
        // elsewhere in Showcase too.
        const currentFolder = folderMembership?.folders.find((folder) =>
          folder.backtestIds?.includes(backtest.id)
        )
        if (currentFolder) {
          await folderMembership?.moveBacktestToFolder(backtest.id, null)
        }
      } else {
        if (!backtest || ['running', 'error'].includes(backtest.status)) {
          return
        }
        setRecentlyViewedBacktests(backtest)
        await setDoc(doc(savedShowcaseRef, backtest.id), backtest)
      }
    } catch (error) {
      console.error('Error toggling favorite: ', error)
    }
  }

  return { isFavorited, toggleFavorite }
}

export default useFavoriteBacktest
